import { CircleCheck, TriangleAlert } from 'lucide-react'

import { type ToastProps } from '../types'
import loaderIcon from '../loader-white.svg'

const getToastIcon = (toastType: ToastProps['type']) => {
  switch (true) {
    case toastType === 'success':
      return <CircleCheck color="white" />
    case toastType === 'error':
      return <TriangleAlert color="white" />
    case toastType === 'loading':
      return (
        <img
          src={loaderIcon}
          className="animate-forward animate-spin [animation-direction:reverse]"
        />
      )
    default:
      return null
  }
}

export default getToastIcon
